// extracted by mini-css-extract-plugin
module.exports = {"searchList":"_2-z97"};